// import ModalForm from "./Form";
import ScheduleRecommendationTableForm from "./ScheduleRecommendationTableForm";
import {
	SCHEDULE_RECOMMENDATION,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const ScheduleRecommendationTableSchema = {
	components: { ScheduleRecommendationTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: SCHEDULE_RECOMMENDATION + "?assign_schedule=" + this.assignScheduleRowData.id,
			tableId: "schedule-recommendation-table",
			formId: "schedule-recommendation-table-form",
			rowData: {},
			tableColumns: [
				{
					title: " Class Name",
					type: "custom-html",
					key: "course_id",
					modifier: (value) => {
						return value.course_name;
					},
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name;
					},
				},
				{
					title: "Mon",
					type: "text",
					key: "time_1",
				},
				{
					title: "Tue",
					type: "text",
					key: "time_2",
				},
				{
					title: "Wed",
					type: "text",
					key: "time_3",
				},
				{
					title: "Thu",
					type: "text",
					key: "time_4",
				},
				{
					title: "Fri",
					type: "text",
					key: "time_5",
				},
				{
					title: "Sat",
					type: "text",
					key: "time_6",
				},
				{
					title: "Start Date",
					type: "text",
					key: "date_start",
				},
                {
					title: "CLC Date",
					type: "text",
					key: "date_clc_start",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ScheduleRecommendationTable",
				url: SCHEDULE_RECOMMENDATION + "?assign_schedule=" + this.assignScheduleRowData.id,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "eye",
						type: "none",
						// component: "app-add-modal",
						component: "schedule-recommendation-table-form",
						modalId: "schedule-recommendation-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						disabled: (rowData) => this.isScheduleRecommendationDeleteDisabled(rowData),
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isScheduleRecommendationDeleteDisabled(rowData) {
			if (rowData.invoice_id) {
				return rowData.invoice_id.status.toLowerCase() === "processed" ? true : false;
			} else {
				return false;
			}
		}
	},
};
